/**
 * What a rep sees when a call to the backend's bot routes fails. The backend
 * answers 401 when the Firebase token is missing or expired and 403 when the
 * user may not act on that bot (only the user who added a bot may remove it).
 */
export const BOT_API_COPY = {
  sessionExpired: 'Your session expired, sign in again.',
  removeForbidden: "You don't have permission to remove this bot.",
  removeFailed: 'Failed to remove bot. Please try again.',
  /** Remove Bot found the bot already out of the call: a notice, not an error (the session still ends). */
  botAlreadyLeft: 'The bot had already left the call.',
  joinForbidden: "You don't have permission to join this bot's session.",
  sessionsForbidden: "You don't have permission to see these sessions.",
  sessionsFailed: 'Failed to load sessions. Please try again.',
} as const;

/**
 * Which app added a bot (owner, 2026-10-07): sent as `clientPlatform` on
 * POST /api/bots/create so the admin portal's Sessions list can show Web /
 * Mac / Windows. The backend accepts web, macos and windows
 * (constants/clientPlatforms.js there).
 */
export const BOT_CLIENT_PLATFORM = 'web' as const;

export const HTTP_UNAUTHORIZED = 401;
export const HTTP_FORBIDDEN = 403;
/** Remove Bot: the backend no longer knows the bot, so it is not in the call. */
export const HTTP_NOT_FOUND = 404;
/** A mic join on your own desktop call (the creator already streams as `salesperson`). */
export const HTTP_CONFLICT = 409;

/**
 * How a Remove Bot ended. The backend decides (owner, 2026-10-03): `removed`,
 * the bot left the call now; `alreadyEnded`, it was no longer in the call
 * (`{ alreadyEnded: true }`, or a 404). Both end the session the same way.
 */
export const BOT_REMOVAL_OUTCOME = {
  removed: 'removed',
  alreadyEnded: 'alreadyEnded',
} as const;

export type BotRemovalOutcome = (typeof BOT_REMOVAL_OUTCOME)[keyof typeof BOT_REMOVAL_OUTCOME];
